import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { SearchProvider } from "./contexts/SearchContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Header from "./components/Header/Header";
import HeroSection from "./components/HeroSection/HeroSection";
import ProfileSection from "./components/ProfileSection/ProfileSection";
import VideoSection from "./components/VideoSection/VideoSection";
import MobileNav from "./components/MobileNav/MobileNav";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ScrollRestoration from "./components/ScrollRestoration/ScrollRestoration";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import LinksPage from "./pages/LinksPage/LinksPage";
import WatchTogetherPage from "./pages/WatchTogetherPage/WatchTogetherPage";
import SearchPage from "./pages/SearchPage/SearchPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import DiscordArchivePage from "./pages/DiscordArchivePage/DiscordArchivePage";
import "./App.css";

/// ホームページコンポーネント
const HomePage: React.FC = () => {
  return (
    <>
      <main className="main-content">
        <HeroSection />
        <ProfileSection />
        <VideoSection />
      </main>
      <footer className="footer desktop-footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-info">
              <h3 className="footer-title">
                マール・アストレア非公式ファンサイト
              </h3>
              <p className="footer-description">
                見習い神官として多くの方に癒しをお届けしていたマール・アストレアの
                <br />
                大切な思い出を永久保存するファンサイトです。
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="footer-copyright">
              © 2025 マール・アストレア非公式ファンサイト. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

/// アプリケーションのメインコンテンツ - ルーティングとヘッダー表示を制御
const AppContent: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {(isDesktop || isHomePage) && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/links" element={<LinksPage />} />
        <Route path="/watch-together" element={<WatchTogetherPage />} />
        <Route path="/search" element={<SearchPage />} />
        {/* 隠しURL - Discordアーカイブ（パスコード認証必須） */}
        <Route path="/sheep/discord-archive" element={<DiscordArchivePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <MobileNav />
      <ScrollToTop />
    </>
  );
};

/// メインアプリケーションコンポーネント - マール・アストレア非公式ファンサイト
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <SearchProvider>
          <Router>
            <ScrollRestoration />
            <AppContent />
          </Router>
        </SearchProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
